import { render, staticRenderFns } from "./WorkspaceObjectSelector.vue?vue&type=template&id=c9faa510&scoped=true&"
import script from "./WorkspaceObjectSelector.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceObjectSelector.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceObjectSelector.vue?vue&type=style&index=0&id=c9faa510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9faa510",
  null
  
)

export default component.exports